import React from "react"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  destaque: {
    marginBottom: theme.spacing(1.5),
    fontSize: 14,
    lineHeight: 1.55,
    color: theme.palette.neutral400,
  },
  secaoTitulo: {
    marginBottom: theme.spacing(0.75),
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.4,
    color: theme.palette.neutral500,
  },
  lista: {
    margin: 0,
    marginBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2.5),
  },
  item: {
    fontSize: 14,
    lineHeight: 1.55,
    color: theme.palette.neutral400,
    marginBottom: theme.spacing(0.5),
  },
  rodape: {
    fontSize: 13,
    lineHeight: 1.45,
    color: theme.palette.neutral300,
  },
}))

export const USUARIO_INATIVACAO_TITULO = "Inativar este usuário?"
export const USUARIO_REATIVACAO_TITULO = "Reativar este usuário?"
export const USUARIO_INATIVACAO_BOTAO_CONFIRMAR = "Inativar"
export const USUARIO_INATIVACAO_BOTAO_CANCELAR = "Cancelar"
export const USUARIO_INATIVACAO_BOTAO_PROCESSANDO = "Inativando..."

const formatarContagem = (nValor, cSingular, cPlural) => {
  const nTotal = Number(nValor) || 0
  return `${nTotal} ${nTotal === 1 ? cSingular : cPlural}`
}

export const UsuarioInativacaoModalConteudo = ({
  nConversasAtivasComoResponsavel = 0,
  nFilasComoResponsavel = 0,
  lCarregando = false,
}) => {
  const classes = useStyles()

  if (lCarregando) {
    return (
      <Typography className={classes.destaque}>Carregando informações do usuário…</Typography>
    )
  }

  const nConversas = Number(nConversasAtivasComoResponsavel) || 0
  const nFilas = Number(nFilasComoResponsavel) || 0

  return (
    <>
      <Typography className={classes.destaque}>
        O acesso ao sistema será bloqueado e a licença ficará disponível para outro usuário.
      </Typography>
      <Typography className={classes.destaque}>
        O usuário está definido como responsável por{" "}
        <strong>{formatarContagem(nConversas, "conversa ativa", "conversas ativas")}</strong> e é responsável por{" "}
        <strong>{formatarContagem(nFilas, "fila de atendimento", "filas de atendimento")}</strong>.
      </Typography>
      <Typography className={classes.secaoTitulo} component="p">
        O que acontece ao confirmar
      </Typography>
      <ul className={classes.lista}>
        <li className={classes.item}>
          <strong>Conversas externas:</strong> passam para pendente, sem responsável
        </li>
        <li className={classes.item}>
          <strong>Conversas internas:</strong> permanecem abertas apenas para consulta do histórico
        </li>
        <li className={classes.item}>
          <strong>Filas de atendimento:</strong> a responsabilidade nas filas em que atua será removida
        </li>
      </ul>
      <Typography className={classes.rodape}>Nenhum dado será apagado.</Typography>
    </>
  )
}

export const UsuarioReativacaoModalConteudo = () => {
  const classes = useStyles()

  return (
    <>
      <Typography className={classes.destaque}>
        Este usuário voltará a acessar o sistema normalmente.
      </Typography>
      <Typography className={classes.destaque}>
        Uma licença da empresa será utilizada novamente por esta conta.
      </Typography>
      <Typography className={classes.rodape}>Deseja continuar?</Typography>
    </>
  )
}
